var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { Avatar, Card, Text } from '@philips-internal/oswald-ui-components/lib/components';
import { string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import simpleAvatarIcon from '../../../assets/images/icons/avatar_user.svg';
import './card-appointments-detail-patient.css';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import { SelectionType, Size } from '@philips-internal/oswald-ui-constants';
let CardAppointmentsDetailPatient = class CardAppointmentsDetailPatient extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            data: {},
        };
    }
    static { this.propTypes = {
        dsConvenio: string,
        fotoPaciente: string,
        nmPaciente: string
    }; }
    render() {
        const { fotoPaciente, nmPaciente, dsConvenio } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement(Text, { bold: true, value: MessageService.translate('patient.details'), className: 'title-patient' }),
            React.createElement(Card, { className: 'card-appointments-detail-patient', width: 12, selectable: false, selectionType: SelectionType.NONE, uuid: generateUUID() },
                React.createElement("div", { className: "container-title appointments-patient-card" },
                    React.createElement("div", { className: "column-avatar" },
                        React.createElement(Avatar, { image: fotoPaciente ? ('data:image/png;base64, ' + fotoPaciente) : simpleAvatarIcon, size: Size.MEDIUM, title: nmPaciente })),
                    React.createElement(Text, { bold: true, value: dsConvenio, className: 'column-patient-text' })))));
    }
};
CardAppointmentsDetailPatient = __decorate([
    AwesomeComponent({ type: ComponentType.DATA_DISPLAY })
], CardAppointmentsDetailPatient);
export default CardAppointmentsDetailPatient;
//# sourceMappingURL=card-appointments-detail-patient.js.map